var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-coefficient-container"},[_c('div',{staticClass:"tag-coefficient-triangle"}),_c('span',{staticClass:"tag-name-coefficient"},[_vm._v("Coefficient "+_vm._s(_vm.coefficient))])])}
var staticRenderFns = []

export { render, staticRenderFns }